/**
 * Created by yangjiao on 2020/5/8.
 */
import request from './http'
const businessUrl = '/apass-business'
const baseUrl = '/apass-base'
const basemopower = '/mopower-athena'
export const getSheetList = (data: any) =>
  request({
    url: businessUrl + '/api/worksheetGrouping/get/' + data.id,
    method: 'get'
  })
// 获取工作表字段  
export const getSheetConfig = (data: any) =>
  request({
    url: businessUrl + '/api/worksheet/getConfig',
    method: 'post',
    data
  })
export const addSheet = (data: any) =>
  request({
    url: businessUrl + '/api/worksheet/insert',
    method: 'post',
    data
  })

export const updateSheet = (data: any) =>
  request({
    url: businessUrl + '/api/worksheet/update',
    method: 'post',
    data
  })
export const deleteSheet = (data: any) =>
  request({
    url: businessUrl + '/api/worksheet/delete/' + data.id,
    method: 'get'
  })
export const copySheet = (data: any) =>
  request({
    url: businessUrl + '/api/worksheet/copy/' + data.id,
    method: 'get'
  })
export const addView = (data: any) =>
  request({
    url: businessUrl + '/api/view/insert',
    method: 'post',
    data
  })
export const renameView = (data: any) =>
  request({
    url: businessUrl + '/api/view/rename',
    method: 'post',
    data
  })
export const configView = (data: any) =>
  request({
    url: businessUrl + '/api/view/config',
    method: 'post',
    data
  })
export const deleteView = (id) =>
  request({
    url: businessUrl + `/api/view/delete/${id}`,
    method: 'get',
  })
export const searchView = (id) =>
  request({
    url: businessUrl + `/api/view/search/${id}`,
    method: 'get',
  })
export const copyView = (id) =>
  request({
    url: businessUrl + `/api/view/copy/${id}`,
    method: 'get',
  })
/* 筛选 */
export const addFilter = (data) =>
  request({
    url: businessUrl + `/api/filter/insert`,
    method: 'post',
    data
  })
export const searchFilterList = (worksheetId) =>
  request({
    url: businessUrl + `/api/filter/list/${worksheetId}`,
    method: 'get',
  })
export const searchFilterById = (id) =>
  request({
    url: businessUrl + `/api/filter/search/${id}`,
    method: 'get',
  })
export const updateBaseInfoFilter = (data) =>
  request({
    url: businessUrl + `/api/filter/updateBaseInfo`,
    method: 'post',
    data
  })
export const updateFilterInfo = (data) =>
  request({
    url: businessUrl + `/api/filter/updateFilterInfo`,
    method: 'post',
    data
  })
export const deleteFilterById = (id) =>
  request({
    url: businessUrl + `/api/filter/delete/${id}`,
    method: 'get',
  })
export const copyFilterById = (id) =>
  request({
    url: businessUrl + `/api/filter/copy/${id}`,
    method: 'get',
  })
export const isAdmin = (applicationId: string) =>
  request({
    url: baseUrl + `/server/role/isAdmin/${applicationId}`,
    method: 'get',
  })
export const getRolesByApplicationId = (data: any) =>
  request({
    url: baseUrl + '/api/roles/rolesWithUsersAndDepartments/' + data.id,
    method: 'get',
  })
export const addUserByRoleId = (data: any) =>
  request({
    url: baseUrl + '/api/roleUsers/insert',
    method: 'post',
    data
  })
export const addDeptByRoleId = (data: any) =>
  request({
    url: baseUrl + '/api/roleDepartments/insert',
    method: 'post',
    data
  })
export const getAllResourceByApplicId = (data: any) =>
  request({
    url: baseUrl + '/api/roles/roleTemplate/' + data.id,
    method: 'post',
    data
  })
// 添加或编辑角色
export const addOrEditRole = (data: any) =>
  request({
    url: baseUrl + '/api/roles/save',
    method: 'post',
    data
  })
// 复制角色
export const copyRole = (data: any) =>
  request({
    url: baseUrl + '/api/roles/copy/' + data.id,
    method: 'post'
  })
// 删除角色
export const deleteRole = (data: any) =>
  request({
    url: baseUrl + '/api/roles/delete/' + data.id,
    method: 'post'
  })
export const editRoleById = (data: any) =>
  request({
    url: baseUrl + '/api/roles/' + data.id,
    method: 'get'
  })
// 删除角色下的成员
export const deleteRoleMembers = (data: any) =>
  request({
    url: baseUrl + '/api/roles/deleteRoleMembers',
    method: 'post',
    data
  })
// 新增分组
export const addSheetGroup = (data: any) =>
  request({
    url: businessUrl + '/api/worksheetGroup/insert',
    method: 'post',
    data
  })
// 删除分组
export const deleteSheetGroup = (data: any) =>
  request({
    url: businessUrl + '/api/worksheetGroup/delete/' + data.id,
    method: 'get'
  })
// 修改分组
export const updateSheetGroup = (data: any) =>
  request({
    url: businessUrl + '/api/worksheetGroup/update',
    method: 'post',
    data
  })
// 移动分组/工作表
export const moveSheetGroup = (data: any) =>
  request({
    url: businessUrl + '/api/worksheet/move',
    method: 'post',
    data
  })
export const addRecord = (data: any) =>
  request({
    url: businessUrl + '/api/record/insert',
    method: 'post',
    data
  })
// 添加双向关联记录    
export const addRecordBidirectional = (data: any) =>
  request({
    url: businessUrl + '/api/record/bidirectionalAssociations/addRecord',
    method: 'post',
    data
  })
// 关联双向关联记录  
export const relevanceRecord = (data: any) =>
  request({
    url: businessUrl + '/api/record/bidirectionalAssociations/relevanceRecord',
    method: 'post',
    data
  })
// 删除双向关联记录   
export const deleteRecordBidirectional = (data: any) =>
  request({
    url: businessUrl + '/api/record/bidirectionalAssociations/removeRecord',
    method: 'post',
    data
  })
export const getRecordList = (data: any) =>
  request({
    url: businessUrl + '/api/record/list',
    method: 'post',
    data
  })
export const getRecordById = (data: any) =>
  request({
    url: businessUrl + '/api/record/search',
    method: 'post',
    data
  })
export const updateRecord = (data: any) =>
  request({
    url: businessUrl + '/api/record/update',
    method: 'post',
    data
  })
export const deleteRecord = (data: any) =>
  request({
    url: businessUrl + '/api/record/delete',
    method: 'post',
    data
  })
export const getAssociationRecordList = (data: any) =>
  request({
    url: businessUrl + '/api/record/listAssociationTableRecord',
    method: 'post',
    data
  })
export const handleCustomTrigger = (data: any) =>
  request({
    url: businessUrl + '/api/workFlow/customTrigger/trigger',
    method: 'post',
    data
  })
export const getAssociationRecordSelect = (data: any) =>
  request({
    url: businessUrl + '/api/record/listAssociationTableSelectRecord',
    method: 'post',
    data
  })
export const addDiscussion = (data: any) =>
  request({
    url: businessUrl + '/api/discussion/insert',
    method: 'post',
    data
  })
export const getDiscussionList = (data: any) =>
  request({
    url: businessUrl + '/api/discussion/list',
    method: 'post',
    data
  })
export const getLogList = (data: any) =>
  request({
    url: businessUrl + '/api/log/list',
    method: 'post',
    data
  })
// 获取视图分组及视图  
export const getViewGroup = (worksheetId: any) =>
  request({
    url: businessUrl + `/api/viewGroup/get/${worksheetId}`,
    method: 'get',
  })
// 获取报表视图分组及视图  
export const getViewGroupReport = (worksheetId: any) =>
  request({
    url: businessUrl + `/api/viewGroup/get/report/${worksheetId}`,
    method: 'get',
  })
export const approvalTrace = (data) =>
  request({
    url: businessUrl + `/api/workFlow/items/approvalTrace`,
    method: 'get',
    params: data
  })
export const getDynamicUser = (data: any) =>
  request({
    url: businessUrl + `/api/user/getDynamicUser`,
    method: 'post',
    data
  })
/**
 *  获取工作表报表接口
 * @param viewId 
 */
export const queryReportByViewId = (viewId) =>
  request({
    url: basemopower + `/api/report/queryByViewId/${viewId}`,
    method: 'get'
  })
// 批量删除子表  
export const childTableBatchDelete = (data) =>
  request({
    url: businessUrl + `/api/record/childTableBatchDelete`,
    method: 'post',
    data
  })

// 获取动态表格关联的工作表记录
export const listDynamicTableRecord = (data: any) =>
  request({
    url: businessUrl + '/api/record/listDynamicTableRecord',
    method: 'post',
    data
  })

// 外部数据查询
export const getExternalData = (data: any, type?) => 
  request({
    url: businessUrl + '/api/externalComponent/data/get',
    method: 'post',
    type,
    data
  })
